const users = {
	title: "Brukere",
	new_user: "Ny bruker",
	edit_user: "Rediger bruker: {name}",
	edit_role: "Rediger rolle: {name}",
	view_user: "Vis bruker: {name}",
	person_title: "Bruker detaljer",
	list_title: "Brukere",
	list_subtitle: "Håndtere brukere",
	details_title: "Bruker detaljer",
	account_title: "Kontodetaljer",
	address_title: "Addresse detaljer",
	organisation_title: "Organisasjons detaljer",
	id: "ID",
	first_name: "Fornavn",
	last_name: "Etternavn",
	middle_name: "Mellomnavn",
	mobile: "Mobil",
	status: "Status",
	email: "Epost",
	password: "Passord",
	search_organisations: "Søk for organisasjoner...",
	profile: "Profil",
	changepass: "Endre passord",
	edit: {
		password_no_match: "Passord er ulike",
		personal_info: "Personlig informasjon",
		old_pass: "Nåværende passord",
		new_pass: "Nytt passord",
		confirm_pass: "Bekreft passord",
		password_success: "Passord endret.",
		password_error: "Endring av passord feilet. Nåværende passord er feil!",
	},
};
export default users;